import { render, staticRenderFns } from "./RecruiterProfileCountGraphical.vue?vue&type=template&id=2bdc5c95&"
import script from "./RecruiterProfileCountGraphical.vue?vue&type=script&lang=js&"
export * from "./RecruiterProfileCountGraphical.vue?vue&type=script&lang=js&"
import style0 from "./RecruiterProfileCountGraphical.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports